import Button from 'lib/ui/Button'
import StreamEditDialog from 'organization/Event/Room/Stream/StreamEditDialog'
import React, {useState} from 'react'
import styled from 'styled-components'
import {ENTERPRISE} from 'obvio/Billing/plans'
import IfOwnerHasPlan from 'organization/auth/IfOwnerPlan'

export default function StreamButton(props: {processing: boolean}) {
  const {processing} = props
  const [streamEditDialogOpen, setStreamEditDialogOpen] = useState(false)

  const handleClick = () => {
    setStreamEditDialogOpen(true)
  }

  return (
    <IfOwnerHasPlan plan={ENTERPRISE}>
      <StyledButton
        color="primary"
        variant="outlined"
        aria-label="custom rtmp stream"
        disabled={processing}
        onClick={handleClick}
      >
        Custom RTMP stream
      </StyledButton>
      <StreamEditDialog
        isOpen={streamEditDialogOpen}
        onClose={() => setStreamEditDialogOpen(false)}
      />
    </IfOwnerHasPlan>
  )
}

const StyledButton = styled(Button)`
  margin-left: ${(props) => props.theme.spacing[3]};
  margin-bottom: ${(props) => props.theme.spacing[6]};
`
